/** @jsx builderX.jsx */

import { builderX, Sprite, Text } from '@gongxigames/framework/core/fragments/BuilderX';

export default (
    <Sprite name='clock'>
        <Text
            position={[3644, 2171]}
            style={{ fontFamily: 'PF DinDisplay Pro', fontSize: 50, fill: '#FFFFFF', align: 'center' }}
            maxWidth={160}
            name='text'
            text='01:32'
        />
    </Sprite>
);
